import React, { useEffect, useState } from 'react';
import { Upload, Button, message } from 'antd';
import apis from '@/apis';
import type { UploadProps } from 'antd';

type Props = {
  maxCount: number;
  onChange: any;
  module: number;
  value?: string[];
  query?: any;
};

const UploadFile: React.FC<Props> = (props) => {
  const [fileList, setFileList] = useState([] as any);
  const { onChange, value } = props;

  useEffect(() => {
    if ('value' in props) {
      setFileList(
        (value || [])?.map((item) => ({ response: item, name: item.split('/').pop(), uid: name, status: 'done' }))
      );
    }
    // eslint-disable-next-line
  }, [value]);

  function customRequest({
    action,
    data,
    file,
    filename,
    headers,
    onError,
    onProgress,
    onSuccess,
    withCredentials,
  }: any) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('module', props.module + '');
    apis
      .fileUpload(formData)
      .then((res) => {
        const { ret } = res;
        if (ret === '0' && res.data) {
          message.success('上传成功');
          onChange([res.data.urlList[0]]);
          // onSuccess(
          //   {
          //     name: filename,
          //     status: 'done',
          //     thumbUrl: res.data.urlList[0],
          //     url: res.data.urlList[0],
          //     success: true,
          //   },
          //   file
          // );
        } else {
          _onError(res.msg);
        }
      })
      .catch(() => {
        _onError('网络异常请稍后重试');
      });

    function _onError(msg: string) {
      message.error(msg);
      setFileList([
        {
          name: file.name,
          uid: name,
          status: 'error',
          response: msg,
        },
      ]);
      onError();
    }

    return {
      abort() {
        console.log('upload progress is aborted.');
      },
    };
  }

  // function customRequest(e: any) {
  //   const formData = new FormData();
  //   const file = e.file;
  //   formData.append('file', file);
  //   formData.append('module', props.module + '');

  //   // module=4
  //   apis
  //     .fileUpload(formData)
  //     .then((res) => {
  //       const { ret } = res;
  //       if (ret && ret === '0' && res.data) {
  //         message.success('上传成功');
  //         e.onSuccess(
  //           {
  //             name: filename,
  //             status: 'done',
  //             thumbUrl: res.data.urlList[0],
  //             url: res.data.urlList[0],
  //           },
  //           file
  //         );
  //         e.onSuccess(res.data.urlList[0]);
  //       } else {
  //         message.error(res.msg);
  //         e.onError();
  //       }
  //     })
  //     .catch((err) => {
  //       message.error(err);
  //     });
  // }

  // const handleChange = ({ fileList: newList }: { fileList: any }) => {
  //   if (!('value' in props)) {
  //     setFileList(newList);
  //   }
  //   // onChange(['xxx.file']);
  //   const value1 = newList?.filter((item: any) => item.status === 'done').map((item: any) => item.response);
  //   if (value1?.length === 0) return;
  //   onChange?.(newList?.filter((item: any) => item.status === 'done').map((item: any) => item.response));
  // };

  const UProps: UploadProps = {
    maxCount: 1,
    customRequest,
    onRemove(item) {
      onChange([]);
    },
    // onChange: handleChange,
    fileList,
  };

  return (
    <Upload {...UProps}>
      <Button type="primary" ghost>
        {props.children || '添加录入文件'}
      </Button>
    </Upload>
  );
};
export default UploadFile;
